import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconClock48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="clock">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.5528 24.8945C23.214 24.7251 23 24.3788 23 24V8.00002C23 7.44774 23.4477 7.00002 24 7.00002C24.5523 7.00002 25 7.44774 25 8.00002V23.382L32.4472 27.1056C32.9412 27.3526 33.1414 27.9533 32.8944 28.4472C32.6474 28.9412 32.0468 29.1414 31.5528 28.8945L23.5528 24.8945Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconClock24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="clock">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4453 12.8321C11.1671 12.6466 11 12.3344 11 12V6.00002C11 5.44773 11.4477 5.00002 12 5.00002C12.5523 5.00002 13 5.44773 13 6.00002V11.4648L15.5547 13.168C16.0142 13.4743 16.1384 14.0952 15.8321 14.5547C15.5257 15.0142 14.9048 15.1384 14.4453 14.8321L11.4453 12.8321Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconClock16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="clock">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.4453 8.83211C7.1671 8.64664 7 8.33441 7 8.00006L7 4.00006C7 3.44777 7.44772 3.00006 8 3.00006C8.55228 3.00006 9 3.44777 9 4.00006V7.46487L10.5547 8.50134C11.0142 8.80769 11.1384 9.42856 10.8321 9.88809C10.5257 10.3476 9.90483 10.4718 9.4453 10.1654L7.4453 8.83211Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
export function IconClock12(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="clock">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.58397 7.12396C5.37533 6.98486 5.25 6.75069 5.25 6.49992V3.49992C5.25 3.08571 5.58579 2.74992 6 2.74992C6.41421 2.74992 6.75 3.08571 6.75 3.49992V6.09853L7.91603 6.87588C8.26067 7.10565 8.3538 7.5713 8.12404 7.91595C7.89427 8.26059 7.42862 8.35372 7.08398 8.12396L5.58397 7.12396Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 11C8.48528 11 10.5 8.98528 10.5 6.5C10.5 4.01472 8.48528 2 6 2C3.51472 2 1.5 4.01472 1.5 6.5C1.5 8.98528 3.51472 11 6 11ZM6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
